var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('input',{ref:"input",attrs:{"accept":_vm.accept,"type":"file","name":"fileUpload"},on:{"change":_vm.onFileChange}})}
var staticRenderFns = []

export { render, staticRenderFns }